import { useMemo } from "react";
import Select from "react-select";
import { getSubscriptionOptions } from "../../Utils/Helper";

const SubscriptionSelect = ({
  value,
  onChange = () => {},
  onBlur,
  placeholder = "Select Subscription",
  isMulti = false,
  includeAllOption = false,
  allLabel = "All",
  selectStyles,
  isClearable,
  ...rest
}) => {
  const baseOptions = useMemo(() => getSubscriptionOptions(), []);

  const options = useMemo(() => {
    if (includeAllOption) {
      return [{ label: allLabel, value: "" }, ...baseOptions];
    }
    return baseOptions;
  }, [baseOptions, includeAllOption, allLabel]);

  const normalizedValue = useMemo(() => {
    if (isMulti) {
      return Array.isArray(value) ? value : [];
    }
    return typeof value === "string" ? value : "";
  }, [isMulti, value]);

  const selectedValue = isMulti
    ? options.filter((option) => normalizedValue.includes(option.value))
    : options.find((option) => option.value === normalizedValue) || null;

  const handleChange = (selected) => {
    if (isMulti) {
      const mappedValues = selected ? selected.map((o) => o.value) : [];
      onChange(mappedValues);
    } else {
      onChange(selected ? selected.value : "");
    }
  };

  const clearable =
    typeof isClearable === "boolean"
      ? isClearable
      : !isMulti && !includeAllOption;

  return (
    <Select
      options={options}
      isMulti={isMulti}
      value={selectedValue}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={onBlur}
      isClearable={clearable}
      theme={(base) => ({
        ...base,
        colors: {
          ...base.colors,
          primary: "#AD5ADC",
          primary25: "#E8DBF3",
          primary50: "#D2B9EA",
        },
      })}
      styles={selectStyles}
      closeMenuOnSelect={
        typeof rest.closeMenuOnSelect === "boolean"
          ? rest.closeMenuOnSelect
          : !isMulti
      }
      {...rest}
    />
  );
};

export default SubscriptionSelect;
